import { AtlassianIcon } from '@atlaskit/logo';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import React from 'react';

const spaLoaderStyles = xcss({
  height: '100vh',
});

const logoStyles = xcss({
  animation: 'loading 2s infinite',
});

export const FullScreenSpaLoader = () => (
  <Inline alignBlock="center" alignInline="center" grow="fill" xcss={spaLoaderStyles} testId="full-screen-spa-loader">
    <Box xcss={logoStyles}>
      <AtlassianIcon appearance="brand" size="xlarge" />
    </Box>
  </Inline>
);
